import React, { useState } from 'react';
import { n8nConversations } from '../data/demoConversations';
import { Bot, User, RefreshCw, ArrowLeft, Phone, Send, MessageSquare } from 'lucide-react';

export function Chatbot() {
  const [selectedChatId, setSelectedChatId] = useState(n8nConversations[0].id);
  const [activeMobileView, setActiveMobileView] = useState('list'); // 'list' | 'chat'
  const [isRefreshing, setIsRefreshing] = useState(false);

  const selectedChat = n8nConversations.find(c => c.id === selectedChatId) || n8nConversations[0];

  const handleSyncRefresh = () => {
    setIsRefreshing(true);
    setTimeout(() => setIsRefreshing(false), 500);
  };

  const handleSelectConversation = (id) => {
    setSelectedChatId(id);
    setActiveMobileView('chat');
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {activeMobileView === 'chat' && (
            <button
              type="button"
              onClick={() => setActiveMobileView('list')}
              className="chat-back-btn"
              style={{
                display: 'none',
                alignItems: 'center',
                gap: '6px',
                padding: '6px 12px',
                borderRadius: '6px',
                border: '1px solid #D4D4D8',
                backgroundColor: '#FFFFFF',
                color: '#09090B',
                fontSize: '12.5px',
                fontWeight: 600,
                cursor: 'pointer'
              }}
            >
              <ArrowLeft size={15} />
              <span>Back</span>
            </button>
          )}
          <h2 style={{ fontSize: '18px', fontWeight: 700, color: '#09090B' }}>Chatbot Logs</h2>
        </div>

        <button
          type="button"
          onClick={handleSyncRefresh}
          style={{
            height: '36px',
            padding: '0 12px',
            borderRadius: '6px',
            border: '1px solid #D4D4D8',
            backgroundColor: '#FFFFFF',
            color: '#09090B',
            fontSize: '12.5px',
            fontWeight: 500,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}
        >
          <RefreshCw size={13} className={isRefreshing ? 'spin' : ''} />
          <span className="sync-text">Sync Logs</span>
        </button>
      </div>

      {/* Main Responsive Chat Layout */}
      <div className="chatbot-responsive-container">
        {/* Left Column: Chat Threads List */}
        <div className={`card chat-threads-column ${activeMobileView === 'chat' ? 'hide-on-mobile' : ''}`} style={{ padding: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column', height: 'calc(100vh - 180px)', minHeight: '520px' }}>
          <div style={{ padding: '14px 18px', backgroundColor: '#FAFAFC', borderBottom: '1px solid #E4E4E7', fontSize: '13px', fontWeight: 700, color: '#09090B', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span>Conversations</span>
            <span style={{ fontSize: '11.5px', color: '#047857', fontWeight: 600 }}>{n8nConversations.length} Active</span>
          </div>

          <div style={{ flex: 1, overflowY: 'auto' }}>
            {n8nConversations.map((chat) => {
              const isSelected = chat.id === selectedChatId;
              return (
                <div
                  key={chat.id}
                  onClick={() => handleSelectConversation(chat.id)}
                  style={{
                    padding: '14px 18px',
                    borderBottom: '1px solid #F4F4F5',
                    backgroundColor: isSelected ? '#ECFDF5' : '#FFFFFF',
                    cursor: 'pointer',
                    transition: 'all 0.15s ease'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px' }}>
                    <div style={{ fontWeight: 700, fontSize: '13.5px', color: '#09090B' }}>{chat.customerName}</div>
                    <span style={{ fontSize: '11px', color: '#71717A' }}>{chat.lastMessageTime}</span>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
                    <span
                      style={{
                        fontSize: '10.5px',
                        fontWeight: 600,
                        padding: '1px 6px',
                        borderRadius: '4px',
                        backgroundColor: '#F4F4F5',
                        color: chat.channelColor
                      }}
                    >
                      {chat.platform}
                    </span>
                    <span style={{ fontSize: '10.5px', color: '#047857', fontWeight: 600 }}>
                      Score {chat.aiScore}/100
                    </span>
                  </div>

                  <div style={{ fontSize: '12.5px', color: '#52525B', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                    {chat.lastMessage}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Right Column: Chat History Transcript */}
        <div className={`chat-transcript-column ${activeMobileView === 'list' ? 'hide-on-mobile' : ''}`} style={{ display: 'flex', flexDirection: 'column', gap: '12px', height: 'calc(100vh - 180px)', minHeight: '520px' }}>
          {/* Active Chat Header */}
          <div className="card" style={{ padding: '12px 16px', backgroundColor: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <button
                type="button"
                onClick={() => setActiveMobileView('list')}
                className="chat-back-icon-btn"
                style={{
                  display: 'none',
                  background: 'none',
                  border: 'none',
                  color: '#71717A',
                  cursor: 'pointer',
                  padding: '4px'
                }}
              >
                <ArrowLeft size={18} />
              </button>
              <div style={{ width: 36, height: 36, borderRadius: '50%', backgroundColor: '#090D16', color: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '13px', flexShrink: 0 }}>
                {selectedChat.avatar}
              </div>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: '14.5px', fontWeight: 700, color: '#09090B', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{selectedChat.customerName}</div>
                <div style={{ fontSize: '11.5px', color: '#71717A', marginTop: '1px', display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                  <span>{selectedChat.platform}</span>
                  <span>•</span>
                  <span>{selectedChat.phone}</span>
                </div>
              </div>
            </div>

            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: '11.5px', fontWeight: 700, color: '#059669', backgroundColor: '#ECFDF5', padding: '3px 8px', borderRadius: '9999px', display: 'inline-block' }}>
                Score: {selectedChat.aiScore}/100
              </div>
            </div>
          </div>

          {/* Chat Messages Body */}
          <div className="card" style={{ padding: '16px', flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '14px', backgroundColor: '#FAFAFC' }}>
            {selectedChat.messages.map((msg) => {
              const isCustomer = msg.sender === 'user';
              return (
                <div
                  key={msg.id}
                  style={{
                    display: 'flex',
                    justifyContent: isCustomer ? 'flex-start' : 'flex-end',
                    gap: '8px'
                  }}
                >
                  {/* Customer Avatar on Left */}
                  {isCustomer && (
                    <div style={{ width: 30, height: 30, borderRadius: '50%', backgroundColor: '#090D16', color: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: 700, flexShrink: 0 }}>
                      {selectedChat.avatar}
                    </div>
                  )}

                  <div style={{ maxWidth: '85%' }}>
                    <div style={{ fontSize: '10.5px', color: '#71717A', marginBottom: '2px', textAlign: isCustomer ? 'left' : 'right' }}>
                      {isCustomer ? selectedChat.customerName : 'AI Chatbot'} • {msg.time}
                    </div>

                    <div
                      style={{
                        padding: '10px 14px',
                        borderRadius: isCustomer ? '4px 14px 14px 14px' : '14px 14px 4px 14px',
                        backgroundColor: isCustomer ? '#FFFFFF' : '#10B981',
                        color: isCustomer ? '#09090B' : '#FFFFFF',
                        border: isCustomer ? '1px solid #E4E4E7' : 'none',
                        fontSize: '13px',
                        lineHeight: 1.5,
                        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                        wordBreak: 'break-word'
                      }}
                    >
                      {msg.text}
                    </div>
                  </div>

                  {/* AI Chatbot Avatar on Right */}
                  {!isCustomer && (
                    <div style={{ width: 30, height: 30, borderRadius: '50%', backgroundColor: '#ECFDF5', color: '#047857', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      <Bot size={15} />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
